import React from 'react';
import { Helmet } from 'react-helmet';
import { has as _has, isEmpty as _isEmpty } from 'lodash-es';
import ComingSoonImage from 'assets/images/coming-soon.png';
import ErrorPageImage from 'assets/images/error_page.svg';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './system.scss';

const ErrorPage = props => {
  let location = useLocation();
  const { t } = useTranslation();
  const { state } = location;

  if (!_has(state, 'isEnabled') || !_has(state, 'message')) {
    return (
      <div className='c-errorPageContainer'>
        <Helmet title='Page Not Found' />
        <div className='errorCode'>404</div>
        <div className='errorCause'>{t('GRAAS_PAGE_NOT_FOUND_GRAAS')}</div>
        <div className='errorMessage'>{t('GRAAS_PAGE_NOT_FOUND_MESSAGE_GRAAS')}</div>
        <div className='errorImage'>
          <img src={ErrorPageImage} alt='Page Not Found' />
        </div>
        <Link to={'/analyze'} className='c-button is-filled'>
          {t('GRAAS_GO_BACK_GRAAS')}
        </Link>
      </div>
    );
  }

  return (
    <div className='c-errorPageContainer'>
      <Helmet title='Coming Soon' />
      <div className='errorImage'>
        <img src={ComingSoonImage} alt='coming soon' />
      </div>
      <div className='errorCause'>{t('GRAAS_COMING_SOON_GRAAS')}!</div>
      <div className='errorMessage'>{!_isEmpty(state?.message) ? state?.message : t('GRAAS_NOTIFY_FEATURE_READY_GRAAS')}</div>
    </div>
  );
};

export default ErrorPage;
